module.exports = __webpack_public_path__ + "img/大数据.ffd09fdd.png";